import Button from "src/Components/Common/Button";
import setCurrentPage from "src/Utils/setCurrentPage";

const LIST_DATA_INTRO_TEMPLATE = [
  {
    icon: "peopleConnectedByGear",
    iconColor: "white",
    text: `<b>100,000+ </b>\ndigital workers \nempowered`,
    listItemCustomStyle: { width: "230px" },
    textCustomStyle: { fontSize: "24px", letterSpacing: "0.24px" },
  },
  {
    icon: "graphWithMagnificationAndGear",
    iconColor: "white",
    text: `<b>70% </b>improvement \nin employee \nproductivity`,
    listItemCustomStyle: { width: "230px" },
    textCustomStyle: { fontSize: "24px", letterSpacing: "0.24px" },
  },
  {
    icon: "computerWithGearAndCircuits",
    iconColor: "white",
    text: `<b>1 Terabyte of data </b>\nprocessed every \nsingle day`,
    listItemCustomStyle: { width: "230px" },
    textCustomStyle: { fontSize: "24px", letterSpacing: "0.24px" },
  },
  {
    icon: "worldWithCircuits",
    iconColor: "white",
    text: `<b>$200 Billion </b> of \ntransactions \nprocessed per year`,
    listItemCustomStyle: { width: "230px" },
    textCustomStyle: { fontSize: "24px", letterSpacing: "0.24px" },
  },
];

export const DATA_INTRO_EV_2 = {
  styleLeftPanel: {
    paddingRight: 0,
    paddingTop: "54px",
    paddingBottom: "51px",
    borderRadius: "0px 300px 15px 0px",
    minWidth: "1195px",
    minHeight: "845px",
  },
  titleStyle: { marginBottom: "20px" },
  styleListData: { marginTop: "-30px", marginBottom: "35px" },
  panelLogo: "EV/EV_intro_logo_2.png",
  title: `<span style="color: #FF7C04;">AI Platform</span> Enhancing \nDigital Core`,
  text: "PolarisEdge, an AI-powered platform that bridges silos in people, processes, \ndata, and technology for enterprises, amplifying the value of their existing \ndigital core investments.",
  listData: LIST_DATA_INTRO_TEMPLATE,
  rightSideImage: "EV/EV_intro_cycle.png",
  rightSideComponent: (
    <div style={{ position: "absolute", right: "129px", bottom: "121px" }}>
      <Button
        label="About edgeverve"
        onClick={() => setCurrentPage(401)}
        endIcon="play"
      />
    </div>
  ),
  next: {
    label: "NEXT",
    onClick: () => setCurrentPage(403),
    endIcon: "arrow-right",
  },
  back: {
    label: "BACK",
    onClick: () => setCurrentPage(1),
    type: "transparent" as "transparent",
    startIcon: "arrow-left",
  },
  bgImage: "EV/EV_demo_Intro_02.png",
  headerRightText: "GET THE EDGE",
  headerLeftImage: "EdgeverveLogo.png",
};
